import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import { DeleteOutline as DeleteOutlineIcon } from '@mui/icons-material';

interface ClearFieldButtonProps {
  onClear: () => void;
  disabled?: boolean;
  title?: string;
}

const ClearFieldButton: React.FC<ClearFieldButtonProps> = ({
  onClear,
  disabled = false,
  title = 'Clear',
}) => (
  <Tooltip title={title}>
    <span>
      <IconButton size="small" color="error" onClick={onClear} disabled={disabled}>
        <DeleteOutlineIcon sx={{ fontSize: 14 }} />
      </IconButton>
    </span>
  </Tooltip>
);

export default ClearFieldButton;
